module.exports = __webpack_public_path__ + "static/media/1_A1_03.3ae2ed4b.png";